import React, { Fragment, useState, useEffect } from 'react';
import logo from '../assets/images/endless-logo.png'
import { CREATEPASSWORD,NewPassword,RetypePassword,Done,EnterOTP,Resend,ResetPassword,Send} from "../constant";
import axiosConfig from "../services/axiosConfig";
import setHeader from "../components/Functions/setHeader";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


const ForgetPwd = () => {

    const [mail, setMail] = useState("");
    const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6 OTP fields
    const [timer, setTimer] = useState(0); // Timer starts at 0 (hidden)
    const [isDisabled, setIsDisabled] = useState(true); // Disable OTP inputs initially
    const [isOtpVerified, setIsOtpVerified] = useState(false); // Check if OTP is verified
    const [newPassword, setNewPassword] = useState("");
    const [retypePassword, setRetypePassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const navigate = useNavigate();
    
    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsDisabled(true); // Disable OTP input when timer expires
        }
        return () => clearInterval(interval);
    }, [timer]);
    

    const sendOTP = () => {
        const formValues = new FormData();
        formValues.append("mail", mail);

        if(mail == ''){
            toast.error('Please Enter Your Mail ID !');
            return;
        }

        axiosConfig.post("forgot-pwd-send-otp", formValues, setHeader()).then((res) => {

            if (!res.data.error) {
                toast.success(res.data.messages);
                setTimer(180); // Reset timer to 3 minutes
                setIsDisabled(false); // Enable OTP input
            }else{
                toast.error(res.data.messages);
                // setTimer(60); 
                // setIsDisabled(false); 
            }

        }).catch((error)=>{
            console.log(error);
        });
    };


    const handleOTPChange = (index, value) => {
        if (/^\d{0,2}$/.test(value)) {  // Allow max 2 digits
            let newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move focus to the next input field automatically
            if (value.length === 1 && index < otp.length - 1) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const validateOTP = () => {
        const enteredOtp = otp.join(""); // Combine all input fields into one OTP

        const formValues = new FormData();
        formValues.append("otp", enteredOtp);
    
        axiosConfig.post("validate-otp", formValues, setHeader())
            .then((res) => {
                if (!res.data.error) {
                    toast.success(res.data.messages);
                    setIsOtpVerified(true); // Allow password reset
                } else {
                    toast.error(res.data.messages);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const changePassword = () => {
        const formValues = new FormData();
        formValues.append("password", newPassword);
    
        axiosConfig.post("change-password", formValues, setHeader())
            .then((res) => {
                if (!res.data.error) {
                    toast.success(res.data.messages);
                    setTimeout(() => {
                        navigate(`${process.env.PUBLIC_URL}/login`);

                    }, 2000);
                } else {
                    toast.error(res.data.messages);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const handlePasswordChange = (e) => {
        setNewPassword(e.target.value);
        if (retypePassword && e.target.value !== retypePassword) {
            setPasswordError("Passwords do not match");
        } else {
            setPasswordError("");
        }
    };
    
    const handleRetypePasswordChange = (e) => {
        setRetypePassword(e.target.value);
        if (newPassword && e.target.value !== newPassword) {
            setPasswordError("Passwords do not match");
        } else {
            setPasswordError("");
        }
    };
    

    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12 p-0">
                                <div className="auth-innerright">
                                    <div className="reset-password-box">
                                        <div className="text-center"><img src={logo} alt="" /></div>
                                        <div className="card mt-4 mb-0">
                                            <h4>{ResetPassword}</h4>
                                            <div className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label">Enter Your Mail</label>
                                                    <div className="form-row">
                                 
                                                        <div className="col-md-7 col-xl-8">
                                                            <input className="form-control mb-1" type="email" name='mail' onChange={(e) => setMail(e.target.value)}/>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <button className="btn btn-primary m-0" type="submit" onClick={sendOTP}>{Send}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {!isOtpVerified && (
                                                <>
                                                <div className="form-group rounded p-4 opt-box">
                                                    <label className="col-form-label pt-0">{EnterOTP}</label>
                                                    <div className="form-row">
                                                        {otp.map((value, index) => (
                                                            <div className="col" key={index}>
                                                                <input
                                                                    id={`otp-input-${index}`}
                                                                    className="form-control digits text-center opt-text"
                                                                    type="text"
                                                                    value={value}
                                                                    maxLength="1" // Allow max 1 digits
                                                                    onChange={(e) => handleOTPChange(index, e.target.value)}
                                                                    disabled={isDisabled} // Disable when timer expires
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className="form-group form-row mt-3">
                                                    <div className="col-md-4">
                                                        <button className="btn btn-success m-0" disabled={timer === 0} type="submit" onClick={validateOTP}>
                                                            Verify OTP
                                                        </button>
                                                    </div>
                                                </div>
                                                {timer > 0 && (
                                                    <div className="text-center mt-3">
                                                        <span className="text-danger">OTP Expires in: {Math.floor(timer / 60)}:{("0" + (timer % 60)).slice(-2)}</span>
                                                    </div>
                                                )}
                                                <div className="text-center mt-4 mb-4"><span className="reset-password-link">{"If don't receive OTP?"}  <a className="btn-link text-danger" href="#javascript" onClick={sendOTP}>{Resend}</a></span></div>
                                                </>
                                                )}

                                                        
                                                {isOtpVerified && (  
                                                <>                                                    
                                                    <h6 className="f-14 mt-4 mb-3">{CREATEPASSWORD}</h6>
                                                    <div className="form-group">
                                                        <label className="col-form-label">{NewPassword}</label>
                                                        <input className="form-control" name="password" type="password"
                                                        value={newPassword} 
                                                        onChange={handlePasswordChange}/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label">{RetypePassword}</label>
                                                        <input className="form-control" name="confirm-password" type="password" 
                                                        value={retypePassword} 
                                                        onChange={handleRetypePasswordChange} />
                                                        {passwordError && <small className="text-danger">{passwordError}</small>}
                                                    </div>
                                                    <div className="form-group form-row mb-2">
                                                        <div className="col-md-2">
                                                            <button className="btn btn-primary" type="submit" 
                                                            disabled={passwordError || !newPassword || !retypePassword} onClick={changePassword}> {Done}</button>
                                                        </div>
                                                    </div>
                                                </>  
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
            
        </Fragment>
    );
};

export default ForgetPwd;